import React, { useState } from 'react';
import { FiChevronRight, FiMessageSquare, FiCornerUpLeft } from 'react-icons/fi';
import { FaRegThumbsUp, FaThumbsUp } from 'react-icons/fa';

const CommentItem = ({ 
  comment, 
  depth = 0, 
  replyingTo, 
  setReplyingTo,
  replyContents,
  setReplyContents,
  handleReplySubmit,
  isLoading,
  activeComment,
  setActiveComment
}) => {
  const isReplying = replyingTo === comment.id;
  const replyContent = replyContents[comment.id] || '';
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(comment.likes_count || 0);

  // সর্বোচ্চ 5 লেভেল গভীরতা পর্যন্ত অনুমতি দিন
  if (depth > 5) return null;

  const toggleLike = () => {
    setLiked(!liked);
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
  };

  return (
    <div 
      className={`p-2 lg:p-4  transition-colors ${depth > 0 ? 'bg-white' : ''}`}
      onClick={() => setActiveComment(comment.id)}
    >
      <div className={`flex ${depth > 0 ? 'pl-2 lg:pl-4 border-l-2 border-indigo-200' : ''}`}>
        <div className="flex-shrink-0 mr-2">
          <div className={`${depth === 0 ? 'h-10 w-10' : 'h-8 w-8'} rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-semibold`}>
            {comment.user?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <div>
              <span className={`${depth === 0 ? 'font-semibold' : 'font-medium'} text-gray-800`}>
                {comment.user?.name || 'Unknown'}
              </span>
              {/* <span className="text-gray-500 text-xs ml-2">
                {moment(comment.created_at).fromNow()}
              </span> */}
            </div>
            
            {/* {depth > 0 && (
              <span className="text-xs text-gray-500 flex items-center">
                <FiCornerUpLeft className="mr-1" />
                Replying to {comment.parent?.user?.name || 'user'}
              </span>
            )} */}
          </div>
          
          <p className={`${depth === 0 ? 'text-gray-700' : 'text-gray-600'} mb-2`}>
            {comment.content}
          </p>
          
          <div className="flex items-center space-x-4 text-sm text-gray-500">
            <button 
              className={`flex items-center ${liked ? 'text-indigo-600' : ''}`}
              onClick={toggleLike}
            >
              {liked ? <FaThumbsUp className="mr-1" /> : <FaRegThumbsUp className="mr-1" />}
              {likeCount}
            </button>
            
            <button 
              onClick={(e) => {
                e.stopPropagation();
                setReplyingTo(isReplying ? null : comment.id);
              }}
              className={`flex items-center ${isReplying ? 'text-indigo-600' : ''}`}
              disabled={isLoading}
            >
              <FiMessageSquare className="mr-1" />
              Reply
            </button>
          </div>
          
          {isReplying && (
            <form 
              onSubmit={(e) => handleReplySubmit(comment.id, replyContent, e)}
              className="mt-3 bg-white p-3 rounded-lg border border-gray-200"
            >
              <textarea
                value={replyContent}
                onChange={(e) => setReplyContents(prev => ({ 
                  ...prev, 
                  [comment.id]: e.target.value 
                }))}
                placeholder="Write your reply..."
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                rows={2}
                disabled={isLoading}
              />
              <div className="flex justify-end space-x-2 mt-2">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setReplyingTo(null);
                  }}
                  className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50"
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-3 py-1 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition disabled:opacity-50"
                  disabled={isLoading || !replyContent.trim()}
                >
                  Post Reply
                </button>
              </div>
            </form>
          )}
          
          {comment.nested_replies && comment.nested_replies.length > 0 && (
            <div className="mt-3 space-y-3">
              {comment.nested_replies?.map(reply => (
                <CommentItem
                  key={reply.id}
                  comment={reply}
                  depth={depth + 1}
                  replyingTo={replyingTo}
                  setReplyingTo={setReplyingTo}
                  replyContents={replyContents}
                  setReplyContents={setReplyContents}
                  handleReplySubmit={handleReplySubmit}
                  isLoading={isLoading}
                  activeComment={activeComment}
                  setActiveComment={setActiveComment}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommentItem;